import { observable, action, reaction, computed } from 'mobx';

class CommonStore {
  @observable
  token = window.localStorage.getItem('auth-token') ? JSON.parse(window.localStorage.getItem('auth-token')) : null;

  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem('auth-token', JSON.stringify(token));
        } else {
          window.localStorage.removeItem('auth-token');
        }
      }
    );
  }

  @action
  setToken(token) {
    this.token = token;
  }

  @computed
  get isLoggedIn() {
    return !!this.token;
  }

  @action
  unauthorize() {
    this.setToken();
  }
}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js